import { ChangeEvent, FormEvent, useState } from 'react';
import { useTranslation } from '@/context/TranslationContext';
import { useContactForm } from '@/lib/queries/contact';
import toast from 'react-hot-toast';
import styles from './Contact.module.scss';

export default function Contact() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        projectType: '',
        budget: '',
        subject: '',
        message: ''
    });
    const contactMutation = useContactForm();
    const instagramUrl: string = "https://instagram.com/koricode_?igsh=dmlvZnVzZ3BqNQR0&ut-m_source=qr";
    const redditUrl: string = "https://www.reddit.com/user/Acceptable-Snow3379/?utm_source=share&utm_medium=web3x&utm_name=web3xcss&utm_term=1&utm_content=share_button";
    const phoneUrl: string = "tel:+4917662269207";


    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const openEmailClient = () => {
        const { name, email, phone, projectType, budget, subject, message } = formData;
        const mailtoLink = `mailto:kontakt@koricode.de?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
            `Name: ${name}\nE-Mail: ${email}\nTelefon: ${phone}\nProjektart: ${projectType}\nBudget: ${budget}\n\nNachricht:\n${message}`
        )}`;
        window.location.href = mailtoLink;
    };

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault();

        contactMutation.mutate(formData, {
            onSuccess: (result) => {
                if (result.success) {
                    toast.success(t('CONTACT.SUCCESS'));
                    setFormData({ name: '', email: '', phone: '', projectType: '', budget: '', subject: '', message: '' });
                } else {
                    toast.error(t('CONTACT.ERROR'));
                    setTimeout(() => {
                        toast(t('CONTACT.FALLBACK'), { icon: 'ℹ️' });
                        openEmailClient();
                    }, 1000);
                }
            },
            onError: (error) => {
                console.error('Error sending email:', error);
                toast.error(t('CONTACT.ERROR'));
                setTimeout(() => {
                    toast(t('CONTACT.FALLBACK'), { icon: 'ℹ️' });
                    openEmailClient();
                }, 1000);
            }
        });
    };

    return (
        <section id="contact" className={styles.contact}>
            <div className={styles.container}>
                <h2 className={styles.sectionTitle} data-aos="fade-up">{t('CONTACT.TITLE')}</h2>
                <div className={styles.contactContent}>
                    <div className={styles.contactInfo} data-aos="fade-right">
                        <h3>{t('CONTACT.SUBTITLE')}</h3>
                        <p>{t('CONTACT.TEXT')}</p>
                        <div className={styles.infoItem}>
                            <i className='bx bx-envelope'></i>
                            <span>kontakt@koricode.de</span>
                        </div>
                        <div className={styles.infoItem}>
                            <i className='bx bx-map'></i>
                            <span>{t('CONTACT.ADDRESS')}</span>
                        </div>
                        <div className={styles.socialLinks}>
                            <a href={phoneUrl} target="_blank" rel="noopener noreferrer"><i className='bx bx-phone'></i></a>
                            <a href={instagramUrl} target="_blank" rel="noopener noreferrer"><i className='bx bxl-instagram'></i></a>
                            <a href={redditUrl} target="_blank" rel="noopener noreferrer"><i className='bx bxl-reddit'></i></a>
                        </div>
                    </div>
                    <div className={styles.contactForm} data-aos="fade-left">
                        <form onSubmit={onSubmit}>
                            <div className={styles.formGroup}>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder={t('CONTACT.FORM.NAME')}
                                    required
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder={t('CONTACT.FORM.EMAIL')}
                                    required
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder={t('CONTACT.FORM.PHONE')}
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <select
                                    name="projectType"
                                    value={formData.projectType}
                                    onChange={handleChange}
                                    className={`${styles.selectInput} ${!formData.projectType ? styles.placeholder : ''}`}
                                >
                                    <option value="">{t('CONTACT.FORM.PROJECT_TYPE')}</option>
                                    <option value="website">{t('CONTACT.FORM.PROJECT_TYPE.WEBSITE')}</option>
                                    <option value="webapp">{t('CONTACT.FORM.PROJECT_TYPE.WEBAPP')}</option>
                                    <option value="mobile">{t('CONTACT.FORM.PROJECT_TYPE.MOBILE')}</option>
                                    <option value="autoprocessing">{t('CONTACT.FORM.PROJECT_TYPE.BACKENDPROCESS')}</option>
                                    <option value="other">{t('CONTACT.FORM.PROJECT_TYPE.OTHER')}</option>
                                </select>
                            </div>
                            {/* <div className={styles.formGroup}>
                                <select
                                    name="budget"
                                    value={formData.budget}
                                    onChange={handleChange}
                                    className={`${styles.selectInput} ${!formData.budget ? styles.placeholder : ''}`}
                                >
                                    <option value="">{t('CONTACT.FORM.BUDGET')}</option>
                                    <option value="low">{t('CONTACT.FORM.BUDGET.LOW')}</option>
                                    <option value="medium">{t('CONTACT.FORM.BUDGET.MEDIUM')}</option>
                                    <option value="high">{t('CONTACT.FORM.BUDGET.HIGH')}</option>
                                    <option value="premium">{t('CONTACT.FORM.BUDGET.PREMIUM')}</option>
                                </select>
                            </div> */}
                            <div className={styles.formGroup}>
                                <input
                                    type="text"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    placeholder={t('CONTACT.FORM.SUBJECT')}
                                    required
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows={5}
                                    placeholder={t('CONTACT.FORM.MESSAGE')}
                                    required
                                ></textarea>
                            </div>
                            <button type="submit" className={styles.btnSubmit} disabled={contactMutation.isPending}>
                                {contactMutation.isPending ? t('NEWSLETTER.FORM.SUBMITTING') : t('CONTACT.FORM.SUBMIT')}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}
